import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('insuranceAgent');
export interface InsuranceAgentInfoRec {
  id: string;
  userId: string;
  agencyName?: string;
  agentName?: string;
  insuranceType?: string;
  officeAddress?: string;
  officePhone?: string;
  cellPhone?: string;
  email?: string;
  website?: string;
  licenseNumber?: string;
  policyNumbers?: string;
  coverageDetails?: string;
  notes?: string;
  isLocked?: boolean;
}

class InsuranceAgentInfoService {
  async getAllInsuranceAgentInfo(targetUserId?: string): Promise<InsuranceAgentInfoRec[]> {
    const params = targetUserId ? `?targetUserId=${targetUserId}` : '';
    const response = await http.get(`/api/insurance-agent-info${params}`);

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch insurance agent information');
    }

    return response.data.data || [];
  }

  async getInsuranceAgentInfo(targetUserId?: string): Promise<InsuranceAgentInfoRec[]> {
    return this.getAllInsuranceAgentInfo(targetUserId);
  }

  async createInsuranceAgentInfo(data: Partial<InsuranceAgentInfoRec>): Promise<InsuranceAgentInfoRec> {
    const response = await http.post('/api/insurance-agent-info', data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to save insurance agent information');
    }

    return response.data.data;
  }

  async updateInsuranceAgentInfo(id: string, data: Partial<InsuranceAgentInfoRec>): Promise<InsuranceAgentInfoRec> {
    const response = await http.patch(`/api/insurance-agent-info/${id}`, data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update insurance agent information');
    }

    return response.data.data;
  }

  async deleteInsuranceAgentInfo(id: string): Promise<void> {
    const response = await http.delete(`/api/insurance-agent-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete insurance agent information');
    }
  }

  async lockInsuranceAgentInfo(id: string): Promise<void> {
    logger.debug('[Service Debug] Calling lock API for insurance agent ID:', id);
    const response = await http.post(`/api/insurance-agent-info/${id}/lock`);
    logger.debug('[Service Debug] Lock API response:', response.data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to lock insurance agent information');
    }
  }

  async unlockInsuranceAgentInfo(id: string, granteeEmails: string[]): Promise<void> {
    const response = await http.post(`/api/insurance-agent-info/${id}/unlock`, { granteeEmails });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to unlock insurance agent information');
    }
  }

  async getInsuranceAgentAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/insurance-agent-info/${id}/access-grants`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch access grants');
    }

    return response.data.data || [];
  }
}

export const insuranceAgentInfoService = new InsuranceAgentInfoService();